import http from 'plugins/axios';
import moment from 'moment';

export default {
  getShareSwitchList() {
    return http.get({
      url: '/la/admin/miningShare/miningShareBaseSwitch'
    });
  },
  turnOnSwitch(switchKey) {
    return http.post({
      url: '/la/admin/mining/switch/open',
      data: {
        switchKey
      },
      dataType: 'form'
    });
  },
  turnOffSwitch(switchKey) {
    return http.post({
      url: '/la/admin/mining/switch/close',
      data: {
        switchKey
      },
      dataType: 'form'
    });
  },
  getShareChildSwitch({ shareTime }) {
    return http.get({
      url: '/la/admin/miningShare/getMiningShareByShareTime',
      data: {
        shareTime: shareTime ? moment(shareTime).valueOf() : shareTime
      }
    });
  },
  turnOnChildSwitch({ shareTime, validTime }) {
    return http.post({
      url: '/la/admin/miningShare/openMiningShareByShareTime',
      data: {
        shareTime: moment(shareTime).valueOf(),
        validTime: moment(validTime).valueOf()
      },
      dataType: 'form'
    });
  },
  turnOffChildSwitch({ shareTime }) {
    return http.post({
      url: '/la/admin/miningShare/closeMiningShareByShareTime',
      data: {
        shareTime: moment(shareTime).valueOf()
      },
      dataType: 'form'
    });
  },
  checkShare() {
    return http.post({
      url: '/la/admin/miningShare/checkMiningShare'
    });
  },
  getCheckShareList(shareTime) {
    return http.get({
      url: '/la/admin/miningShare/miningShareCheckList',
      data: {
        shareTime: moment(shareTime).valueOf()
      }
    });
  }
};
